<template>
  <input
    type="file"
    @change="handleFileChange" 
    ref="fileInput"
    v-bind="$attrs"
  >
</template>

<script>
export default {
  name: "FileInput",

  inheritAttrs: false,
  
  props: {
    value: {
      type: [File, null],
      default: () => null,
    }
  },

  methods: {
    handleFileChange(event) {
      const file = event.target.files[0]
      if (file) {
        this.$emit('input', file)
      }
    },
    
    reset() {
      this.$refs.fileInput.value = null
      this.$emit('input', null)
    }
  }
}
</script>